





































import { EntityHistory } from "@/entity/EntityHistory";
import { General } from "@/services/General";
import axios from "axios";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
})
export default class EntityHistoryDetail extends Vue {
    @Prop({ required: true })
    entityId: string;

    results: EntityHistory[] = [];
    loading: boolean = false;

    async mounted() {
        await this.searchEntityHistory();
    }

    async searchEntityHistory() {
        this.loading = true;
        try {
            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/net20/GetEntityHistories'),
                data: {
                    entityId: this.entityId,
                },
                withCredentials: true,
                responseType: 'json'
            });
            
            this.results = results.data;
        } catch (error) {
            General.HandleError(error, this);
        } finally {
            this.loading = false;
        }

    }
}
